import { render } from "./UserTrackingHistory.vue?vue&type=template&id=2ccff47d&scoped=true"
import script from "./UserTrackingHistory.vue?vue&type=script&lang=ts"
export * from "./UserTrackingHistory.vue?vue&type=script&lang=ts"

import "./UserTrackingHistory.vue?vue&type=style&index=0&id=2ccff47d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ccff47d"

export default script